/**
 * Known role strings returned by the backend API.
 * Use these constants in route/menu config for type safety and autocomplete.
 */
export const BACKEND_ROLES = {
  ADMIN: "Admin",
  COMPANY_ADMIN: "CompanyAdmin",
  MANAGER: "Manager",
  EXECUTIVE: "Executive",
  PRE_SALES: "Pre Sales",
  HR: "Hr",
  EMPLOYEE: "Employee",
} as const;

export type BackendRole = (typeof BACKEND_ROLES)[keyof typeof BACKEND_ROLES];
